import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MobileNavService {
    private navbar = {show : false};

    constructor() {
//        this.navbar.show = false;
    }

    getSideNav() {
        return this.navbar;
    }

    showSideNav() {
        this.navbar.show = true; // {2}
    }

    hideSideNav() {
        this.navbar.show = false; // {2}
    }


}
